var map = {
	"./close.svg": 5,
	"./docker.svg": 32,
	"./envelope.svg": 33,
	"./figma.svg": 34,
	"./firebase.svg": 35,
	"./git.svg": 36,
	"./github.svg": 37,
	"./instagram.svg": 38,
	"./java.svg": 39,
	"./javascript.svg": 40,
	"./jest.svg": 41,
	"./linkedin.svg": 42,
	"./map-marker.svg": 43,
	"./no-icon.svg": 44,
	"./phone.svg": 45,
	"./postgresql.svg": 46,
	"./react.svg": 47,
	"./recoil.svg": 48,
	"./sass.svg": 49,
	"./spring.svg": 50,
	"./twitter.svg": 51,
	"./typescript.svg": 52,
	"./vue.svg": 53
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4;